import { render, staticRenderFns } from "./page_layout.vue?vue&type=template&id=18b7394a&scoped=true&"
import script from "./page_layout.vue?vue&type=script&lang=js&"
export * from "./page_layout.vue?vue&type=script&lang=js&"
import style0 from "./page_layout.vue?vue&type=style&index=0&id=18b7394a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b7394a",
  null
  
)

export default component.exports